import React from 'react';

const OtherSkills = () => {
    return (
        <div className='otherSkills'>
            <h3>Autres compétences</h3>
            <div className='list'>
                <ul>
                    <li><i className='bi bi-check-square-fill'></i> Anglais professionnel</li>
                    <li><i className='bi bi-check-square-fill'></i> Méthodes Agiles</li>
                    <li><i className='bi bi-check-square-fill'></i> Relation client B2B/B2C</li>
                    <li><i className='bi bi-check-square-fill'></i> Bonne gestion de stress</li>
                </ul>
                <ul>
                <li><i className='bi bi-check-square-fill'></i> Figma</li>
                    <li><i className='bi bi-check-square-fill'></i> Canva</li>
                    <li><i className='bi bi-check-square-fill'></i> Dépannage informatique</li>
                    <li><i className='bi bi-check-square-fill'></i> Wordpress</li>
                </ul>
            </div>
               
        </div>
    );
};

export default OtherSkills;